import { Link, Outlet, useLocation } from "react-router-dom";
import NavBar from "../../Components/NavBar";
import ServicesHomeConatiner from "../../Components/ServiceComp";
import ContainerSize from "../../Components/container";
import OptimizedImage from "../../Components/imageOptimise";
import SEO from "../../Components/SEO";

const Resources = () => {
    const location = useLocation();

    const services = [
        {
            id: 1,
            serviceName: "Blog",
            description: "Insights, Tips and Stories to Keep You Informed and Inspired",
            image: "/images/Resources/blogs-image.jpg",
            path: "/resources/blogs",
        },
        {
            id: 2,
            serviceName: "Brochures",
            description: "Explore Our Detailed Brochures to Discover How We Empower Your Insurance Business",
            image: "/images/Resources/brochers-image.jpg",
            path: "/resources/brochures",
        },
        {
            id: 3,
            serviceName: "Videos",
            description: "Engage, Educate and Inspire with Our Curated Collection of Insightful Videos",
            image: "/images/Resources/video-image.jpg",
            path: "/resources/videos",
        },
    ];

    const serviceContent = {
        "/resources": {
            title: "RESOURCES",
            description: `Welcome to our resources page your essential guide to insurance outsourcing and back office services in the USA. As the insurance industry evolves with new regulations and technology, optimizing operations is no longer optional. Our guides show you how outsourcing key back-office functions can be a strategic move to drive efficiency and growth.`,
            image1: "/images/Resources/resources-main/2.jpg",
            image2: "/images/Resources/resources-main/1.jpg",
        },

        "/resources/blogs": {
            title: "Blogs",
            description: ` Insights, Tips and Stories to Keep You Informed and Inspired.`,
            image1: "/images/Resources/blogs/1.jpg",
            image2: "/images/Resources/blogs/2.jpg",
        },

        "/resources/videos": {
            title: "Videos",
            description: `Engage, Educate and Inspire with Our Curated Collection of Insightful Videos.`,
            image1: "/images/Resources/videos/1.jpg",
            image2: "/images/Resources/videos/2.jpg",
        },

        "/resources/brochures": {
            title: "Brochures",
            description: `At IMASH Technologies, we deliver specialized outsourcing and digital solutions designed to help businesses scale efficiently, reduce operational costs, and improve performance. Explore our service brochures below to understand how we support insurance agencies, startups, and growing businesses worldwide, with a strong focus on the U. S. market.`,
            image1: "/images/Resources/brouchers/1.jpg",
            image2: "/images/Resources/brouchers/2.jpg",
        },
    };

    // Get the content for the current path
    const currentContent =
        serviceContent[location.pathname] || serviceContent["/resources"];

    return (
        <>
        <SEO title="Insurance Outsourcing Resources | imash insure" description="Explore resources, guides, and insights on insurance outsourcing, back-office operations, and efficiency solutions for U.S. agencies."/>
            <NavBar
                bgColor="bg-white-500"
                childrenContainer={
                    <ServicesHomeConatiner
                        title={currentContent.title}
                        description={currentContent.description}

                        image1={currentContent.image1}
                        image2={currentContent.image2}
                    />
                }
            />
            {/* Show services list only if on "/resources" path */}
            {location.pathname === "/resources" && (
                <div className="bg-gray-200 py-10">
                    <ContainerSize>
                        <div className="flex flex-wrap -mx-4 justify-center">
                            {services.map((item) => (
                                <div
                                    key={item.id}
                                    className="w-full md:w-1/2 px-4 mb-8 flex justify-center transition-transform duration-300 hover:-translate-y-3"
                                >
                                    <div className="flex flex-col md:flex-row gap-4 bg-white p-4 rounded shadow w-full max-w-[700px]">
                                        <OptimizedImage
                                            src={item.image}
                                            alt={item.serviceName}
                                            className="w-full md:w-[250px] h-[200px] object-cover rounded"
                                        />
                                        <div className="flex flex-col text-left pt-3">
                                            <h3 className="text-lg font-semibold">{item.serviceName}</h3>
                                            <p className="text-gray-600 text-sm mt-2">{item.description}</p>
                                            <div className="pt-2">
                                                <Link to={item.path}>
                                                    <button className="bg-[#f18801] text-white hover:bg-[#1b4a78] hover:animate-pulse font-semibold py-1 px-6 rounded-full text-[14px] transition duration-300 mt-4 inline-block">
                                                        View More
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ContainerSize>
                </div>
            )}
            <Outlet />
        </>
    );
};

export default Resources;
